'use client'

import CountryLangSelector from '@/components/CountryLangSelector'
import { ProjectReassurance, SubflowReviews } from '@/components/SubflowReviews'
import { usePathname } from '@/navigation'
import { stepPaths } from '@/workflows/steps'

// Grey band of the ratings above the footer, on mobile
const mobileBand = 'bg-white-200 px-6 py-4 md:hidden'

// Footer of the subflow: language of the prospect, ratings of SeDomicilier, copyright. On mobile, the ratings are in
// a grey band above it, with the reassurance of the project step on that step; from tablet, the project step shows
// them in its content instead
const Footer = () => {
  const onProjectStep = usePathname() === stepPaths.project
  const copyright = `© ${new Date().getFullYear()} SeDomicilier`

  return (
    <footer>
      {onProjectStep ? (
        <ProjectReassurance className={mobileBand} />
      ) : (
        <SubflowReviews className={mobileBand} />
      )}
      <div className='relative flex items-center justify-between border-t border-[color:var(--gray-200)] bg-white p-2 md:p-4'>
        <CountryLangSelector />
        {!onProjectStep && (
          <SubflowReviews
            className='absolute top-1/2 left-1/2 hidden -translate-x-1/2 -translate-y-1/2 md:flex'
            titleClassName='hidden xl:block'
          />
        )}
        <p className='pr-2 text-right text-[13px] leading-[18px] text-[color:var(--gray-800)] md:pr-[90px] md:text-base md:leading-5'>
          {copyright}
        </p>
      </div>
    </footer>
  )
}

export default Footer
